// data
import {
    contentTypeModelTypeSite,
} from 'data'

// serializers
import {
    MainIdNameSerializer,
    MainStyleSerializer,
    PageDetailSiteSerializer,
    PortfolioDetailSiteSerializer,
    PortfolioPageContentListSiteSerializer,
} from 'serializers/site'

// main
export const reduxFormInitialHelpersSite: reduxFormHelpersStateSite = {
    buttonDisabled: true,
    errorStatus: undefined,
    hasChanged: false,
    init: false,
    isActionSheetOpen: false,
    isInlineModalOpen: false,
    isLoading: false,
    isSaving: false,
    isSuccess: false,
    mainError: '',
    scrollToTop: false,
}

export type reduxFormHelpersStateSite = {
    buttonDisabled?: boolean
    errorStatus?: number
    hasChanged?: boolean
    init?: boolean
    isActionSheetOpen?: boolean
    isInlineModalOpen?: boolean
    isLoading?: boolean
    isSaving?: boolean
    isSuccess?: boolean
    mainError?: string
    mainErrorTitle?: string
    scrollToTop?: boolean
}

export type reduxFormStateSite = {
    availableContentSources: MainIdNameSerializer[]
    collapseStyles: boolean
    dynamicTextOptions?: {
        [key: number]: MainIdNameSerializer[]
    }
    editAutoSave: {
        [key: number]: {
            styles: MainStyleSerializer
            styles_original: MainStyleSerializer
            udpdateUrl: string
        }
    }
    editAutoSaved: {
        [key: number]: {
            styles: MainStyleSerializer
            styles_original: MainStyleSerializer
            udpdateUrl: string
        }
    }
    editFunction?: () => void
    editUrl?: string
    editingForm: boolean
    hoveredBlockId: number | undefined
    isSuccessModalMessage: string | undefined
    isSuccessModalOpen: boolean
    isSuccessToastMessage: string | undefined
    isSuccessToastOpen: boolean
    modalForm?: {
        alreadyOpenIds?: number[]
        contentType?: contentTypeModelTypeSite
        isOpen?: boolean
        objectId?: number
    }
    navigationMode: 'edit' | 'navPage' | 'navMixed' | 'preview' | undefined
    pageContentItems?: PortfolioPageContentListSiteSerializer[]
    pageObject?: PageDetailSiteSerializer
    parentContent?: number
    permissions?: {
        permissionIsDisabledRest?: boolean
        permissionIsDisabledStyles?: boolean
        permissionIsDisabledText?: boolean
    }
    portfolioObject?: PortfolioDetailSiteSerializer
    sectionCollapse: boolean
    sectionId: number | undefined
    showEditAlert: boolean
    refresh: {
        PrivateDetailPageSite?: number
        refreshDetailSite?: number
        refreshFormSite?: number
    }
    refreshId: {
        PrivateDetailPageSite?: number
    }
    refreshNoEmpty: boolean | undefined
    refreshLearnPage?: number
}
